import { render, staticRenderFns } from "./LIC.vue?vue&type=template&id=6be8d64c&scoped=true&"
import script from "./LIC.vue?vue&type=script&lang=js&"
export * from "./LIC.vue?vue&type=script&lang=js&"
import style0 from "./LIC.vue?vue&type=style&index=0&id=6be8d64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8d64c",
  null
  
)

export default component.exports